<div class="min-h-screen flex items-center justify-center">
  <app-not-found-error></app-not-found-error>
</div>

